import React from "react";
import { Link } from "react-router-dom";
import '../css files/Navbar.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
    faGithub, 
    faLinkedin } from '@fortawesome/free-brands-svg-icons';

const Navbar = () => {
    const linkedInURL = "https://www.linkedin.com/in/mohamed-ali-ahmed-300002216/"
    const gitHubURL = "https://github.com/maahmed24712"
    
    return (
        <div className="Container">
            <div className="Tabs">
                <Link to='/'><button>Home</button></Link>
                <Link to='/skills'><button>Skills</button></Link>
                <Link to='/projects'><button>Projects</button></Link>
            </div>
            <div className="iconBtns">
                <Link to= {linkedInURL} target="blank">
                    <button>
                        <FontAwesomeIcon icon={faLinkedin} />
                    </button>
                </Link>
                <Link to={gitHubURL} target="blank">
                    <button>
                        <FontAwesomeIcon icon={faGithub} />
                    </button>
                </Link>
                
            </div>
            <div className="Contact">
                <Link to='/contact'>
                    <button>Contact Me</button>
                </Link>
            </div>
        </div>
    )
}
export default Navbar;
